//@ts-nocheck

// The full dataOptions object
const dataOptions = {
  temperature: {
    name: "Temperature",
    input_unit: "°F",
    selected_unit: 0,
    units: ["°F", "°C"],
    converter: [
      (value) => value, // For °F -> °F (no conversion needed)
      (value) => ((value - 32) * 5) / 9, // For °F -> °C
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  wind_now: {
    name: "Wind Speed",
    input_unit: "MPH",
    selected_unit: 0,
    units: ["MPH", "KPH", "MPS", "KTS"],
    converter: [
      (value) => value, // For MPH -> MPH (no conversion needed)
      (value) => value * 1.60934, // For MPH -> KPH
      (value) => value * 0.44704, // For MPH -> MPS
      (value) => value * 0.868976, // For MPH -> KTS
    ],
    round: [0,0,0,0],
    chartType: "rangeArea",
  },
  wind_direction: {
    name: "Wind Direction",
    input_unit: "°",
    selected_unit: 0,
    units: ["°"], // No conversion needed for angles
    converter: [
      (value) => value, // For ° -> °
    ],
    round: [0,0],
    chartType: "scatter",
  },
  humidity: {
    name: "Humidity",
    input_unit: "%",
    selected_unit: 0,
    units: ["%"], // No conversion needed
    converter: [
      (value) => value, // For % -> %
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  viewers: {
    name: "Viewers",
    input_unit: "viewers",
    selected_unit: 0,
    units: ["viewers"],
    converter: [
      (value) => value,
    ],
    round: [0],
    chartType: "rangeArea",
  },
  dew_point: {
    name: "Dew Point",
    input_unit: "°F",
    selected_unit: 0,
    units: ["°F", "°C"],
    converter: [
      (value) => value, // For °F -> °F
      (value) => ((value - 32) * 5) / 9, // For °F -> °C
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  pressure: {
    name: "Pressure",
    input_unit: "MB",
    selected_unit: 0,
    units: ["inHg", "mmHg", "MB"],
    converter: [
      (value) => value * 0.02953, // For MB -> inHg
      (value) => value * 0.750062, // For MB -> mmHg
      (value) => value, // For MB -> MB
    ],
    round: [2,0,0],
    chartType: "rangeArea",
  },
  uv: {
    name: "UV Index",
    input_unit: "UV",
    selected_unit: 0,
    units: ["UV"], // No conversion needed
    converter: [
      (value) => value, // For UV -> UV
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  solar_radiation: {
    name: "Solar Radiation",
    input_unit: "W/m²",
    selected_unit: 0,
    units: ["W/m²"], // No conversion needed
    converter: [
      (value) => value, // For W/m² -> W/m²
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  wet_bulb_globe: {
    name: "Wet Bulb Globe Temperature",
    input_unit: "°F",
    selected_unit: 0,
    units: ["°F", "°C"],
    converter: [
      (value) => value, // For °F -> °F
      (value) => ((value - 32) * 5) / 9, // For °F -> °C
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  wind_chill: {
    name: "Wind Chill",
    input_unit: "°F",
    selected_unit: 0,
    units: ["°F", "°C"],
    converter: [
      (value) => value, // For °F -> °F
      (value) => ((value - 32) * 5) / 9, // For °F -> °C
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  heat_index: {
    name: "Heat Index",
    input_unit: "°F",
    selected_unit: 0,
    units: ["°F", "°C"],
    converter: [
      (value) => value, // For °F -> °F
      (value) => ((value - 32) * 5) / 9, // For °F -> °C
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  pm25: {
    name: "PM 2.5",
    input_unit: "µg/m3",
    selected_unit: 0,
    units: ["µg/m3"], // No conversion needed
    converter: [
      (value) => value, // For µg/m3 -> µg/m3
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  pm10: {
    name: "PM 10",
    input_unit: "µg/m3",
    selected_unit: 0,
    units: ["µg/m3"], // No conversion needed
    converter: [
      (value) => value, // For µg/m3 -> µg/m3
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  voc: {
    name: "VOC",
    input_unit: "voc index",
    selected_unit: 0,
    units: ["voc index"], // No conversion needed
    converter: [
      (value) => value, // For voc index -> voc index
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  density_altitude: {
    name: "Density Altitude",
    input_unit: "m",
    selected_unit: 0,
    units: ["FT", "M"],
    converter: [
      (value) => value * 3.28084, // For m -> ft
      (value) => value, // For m -> m
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  rain_min : {
    name: "Rain Rate",
    input_unit: "in/hr",
    selected_unit: 0,
    units: ["IN/HR", "MM/HR"],
    converter: [
      (value) => value * 60, // For in/min -> in/hr
      (value) => value * 25.4 * 60, // For in/min -> mm/hr
    ],
    round: [2,0],
    chartType: "rangeArea",
  },
  rain : {
    name: "Total Rainfall",
    input_unit: "in",
    selected_unit: 0,
    units: ["IN", "MM"],
    converter: [
      (value) => value, // For in -> in
      (value) => value * 25.4, // For in -> mm
    ],
    round: [2,0],
    chartType: "rangeArea",
    // Note: This value is calculated by the backend by summing all rain_rate updates (in/minute)
  },
  strikes_per_minute: {
    name: "Strikes per Minute",
    input_unit: "strikes/min",
    selected_unit: 0,
    units: ["strikes / min"], // No conversion needed
    converter: [
      (value) => value, // For strikes/min -> strikes/min
    ],
    round: [0,0],
    chartType: "rangeArea",
  },
  nearest_strike_distance: {
    name: "Lightning Distance",
    input_unit: "km",
    selected_unit: 0,
    units: ["mi", "km"],
    converter: [
      (value) => value / 1.60934, // For km -> miles
      (value) => value , // For km -> km
    ],
    round: [1,0],
    chartType: "rangeArea",
  },
  nearest_fire_distance: {
    name: "Fire Distance",
    input_unit: "mi",
    selected_unit: 0,
    units: ["mi", "km"],
    converter: [
      (value) => value, // For mi -> mi
      (value) => value * 1.60934, // For mi -> km
    ],
    round: [1,0],
    chartType: "rangeArea",
  },
  wind_gust: {
    name: "Wind Gust",
    input_unit: "MPH",
    selected_unit: 0,
    units: ["MPH", "KPH", "MPS", "KTS"],
    converter: [
      (value) => value, // For MPH -> MPH (no conversion needed)
      (value) => value * 1.60934, // For MPH -> KPH
      (value) => value * 0.44704, // For MPH -> MPS
      (value) => value * 0.868976, // For MPH -> KTS
    ],
    round: [0,0,0,0],
    chartType: "rangeArea",
  },
  wind_lull: {
    name: "Wind Lull",
    input_unit: "MPH",
    selected_unit: 0,
    units: ["MPH", "KPH", "MPS", "KTS"],
    converter: [
      (value) => value, // For MPH -> MPH (no conversion needed)
      (value) => value * 1.60934, // For MPH -> KPH
      (value) => value * 0.44704, // For MPH -> MPS
      (value) => value * 0.868976, // For MPH -> KTS
    ],
    round: [1,1,2,2],
    chartType: "rangeArea",
  },
  wind_avg: {
    name: "Average Wind Speed",
    input_unit: "MPH",
    selected_unit: 0,
    units: ["MPH", "KPH", "MPS", "KTS"],
    converter: [
      (value) => value, // For MPH -> MPH (no conversion needed)
      (value) => value * 1.60934, // For MPH -> KPH
      (value) => value * 0.44704, // For MPH -> MPS
      (value) => value * 0.868976, // For MPH -> KTS
    ],
    round: [1,1,2,2],
    chartType: "rangeArea",
  },
  wind_direction_avg: {
    name: "Average Wind Direction",
    input_unit: "°",
    selected_unit: 0,
    units: ["°"], // No conversion needed for angles
    converter: [
      (value) => value, // For ° -> °
    ],
    round: [0],
    chartType: "scatter",
  },
  pm1: {
    name: "PM 1.0",
    input_unit: "µg/m3",
    selected_unit: 0,
    units: ["µg/m3"], // No conversion needed
    converter: [
      (value) => value, // For µg/m3 -> µg/m3
    ],
    round: [0],
    chartType: "rangeArea",
  },
  pm1_aqi: {
    name: "PM 1.0 AQI",
    input_unit: "AQI",
    selected_unit: 0,
    units: ["AQI"],
    converter: [
      (value) => value, // For AQI -> AQI
    ],
    round: [0],
    chartType: "rangeArea",
  },
  pm25_aqi: {
    name: "PM 2.5 AQI",
    input_unit: "AQI",
    selected_unit: 0,
    units: ["AQI"],
    converter: [
      (value) => value, // For AQI -> AQI
    ],
    round: [0],
    chartType: "rangeArea",
  },
  pm10_aqi: {
    name: "PM 10 AQI",
    input_unit: "AQI",
    selected_unit: 0,
    units: ["AQI"],
    converter: [
      (value) => value, // For AQI -> AQI
    ],
    round: [0],
    chartType: "rangeArea",
  },
  significant_wave_height: {
    name: "Significant Wave Height",
    input_unit: "FT",
    selected_unit: 0,
    units: ["FT", "M"],
    converter: [
      (value) => value,
      (value) => value / 3.28084,
    ],
    round: [1, 2],
    chartType: "rangeArea",
  }
 
};

// Weather aggregation options by time range
export const aggregationByRange = {
  "15m": ["none", "1m", "2m"],
  "1h": ["none", "2m", "5m", "10m"],
  "2h": ["2m", "5m", "10m"],
  "6h": ["5m", "10m", "15m"],
  "12h": ["10m", "15m", "30m"],
  "24h": ["5m", "10m", "15m"],
  "2d": ["10m", "15m", "30m"],
  "7d": ["15m", "30m", "60m"]
};

// Default weather metrics to display
export const displayMetrics = [
  "temperature",
  "wind_now",
  "viewers",
  "humidity",
  "wind_direction",
  "dew_point",
  "pressure",
  "rain",
  "rain_min",
  "strikes_per_minute",
  "nearest_strike_distance",
  "significant_wave_height",
];

export default dataOptions;
